import classnames from "classnames";
import { forwardRef, useState } from "react";

import styles from "./ContentEditable.module.scss";

interface ContentEditableProps {
  readonly className?: string;
  readonly editable?: boolean;
  readonly placeholder?: string;
  readonly onEnter: (value: string) => void;
  readonly clearOnEnter?: boolean;
}
const ContentEditable = forwardRef<HTMLDivElement, ContentEditableProps>(
  (
    { className, editable = true, placeholder, onEnter, clearOnEnter = true },
    ref
  ) => {
    const [value, setValue] = useState("");

    return (
      <div
        ref={ref}
        role="textbox"
        className={classnames(styles.editable, className)}
        // @ts-expect-error https://github.com/DefinitelyTyped/DefinitelyTyped/pull/67170
        placeholder={placeholder}
        contentEditable={true}
        suppressContentEditableWarning={true}
        onBlur={(e) => {
          if (!editable) {
            return;
          }
          setValue(e.target.textContent ?? "");
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            // @ts-expect-error - TS2339 - Property 'textContent' does not exist on type 'EventTarget'.
            onEnter(e.target.textContent ?? "");
            if (clearOnEnter) {
              e.currentTarget.innerHTML = "";
            }
            e.currentTarget.blur();
          }
        }}
      >
        {value}
      </div>
    );
  }
);

export default ContentEditable;
